import React from 'react'
import Link from 'gatsby-link'
import Header from "../components/header";
// import CTA from "../components/cta";
// import CountdownWidget from "../components/countdown-widget";
import Countdown from "../components/countdown";
import PrivateMastermind from "../components/private-mastermind";
import ETSection1 from "../components/et-section1";
import RealSection from "../components/real-section";
import GerardSection from "../components/gerard-section";
import ETSection2 from "../components/et-section2";
import TransformationSection from "../components/transformation-section";
import ExpectSection from "../components/expect-section";
import BestVersion from "../components/best-version";
import AgendaSection from "../components/agenda-section";
import PricingSection from "../components/pricing-section";
import RSVPSection from "../components/rsvp-section";
import Sponsors from "../components/sponsors";
import JoinusSection from "../components/joinus-section";
import FooterWidget from "../components/footer-widget";
// import BlackfridayWidget from "../components/blackfriday";

const IndexPage = () => (
    <div>
        <div className="row m0">
            <div className="col s12 p0">

                {/*<BlackfridayWidget/>*/}
               <Header/>

                {/*<CountdownWidget/>*/}
                <Countdown/>

                <PrivateMastermind/>

                <ETSection1/>

                <RealSection/>

                <GerardSection/>

                <ETSection2/>

                <TransformationSection/>

                <ExpectSection/>

                <BestVersion/>

                <AgendaSection/>

                <PricingSection/>

                <RSVPSection/>

                <Sponsors/>

                <JoinusSection/>

                <FooterWidget/>

            </div>
        </div>
        {/*<Link to="/page-2/">Go to page 2</Link>*/}
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js